<template>
  <div class=" is-fullwidth">
    <div v-if="garment_id == 0">
      <div class="is-pulled-left">
        <button class="button" :class="{'is-success' : this.include_hidden == true}" @click="updateIncludeHidden()">Include Hidden</button>
      </div>
      <div class="is-pulled-right mb-2" v-if="loading == false && garments.length > 0">
            
            <input class="input" v-model="search" placeholder="search garments ..."/>
            
        </div>
        <br style="clear:both" />
      <div class="notification is-info" v-if="loading === true">Loading garments ...</div>
      <div class="notification is-warning" v-if="loading == false && filteredGarments.length == 0">There are now garments to show</div>

      
      <div v-if="loading == false && filteredGarments.length > 0">
          
          <table class="table is-hoverable is-fullwidth is-size-7" id="garmentstable" >
            <thead>
              <th width="45">ID</th>
              <th>Garment Name</th>
              <th>General Range</th>
              <th>SKU Range/Code</th>
              <th>Style/Code</th>
              <th>Delivery</th>
              <th>F/P</th>
              <th>P/P</th>
              <th>C/S</th>
              <th>Approved</th>
              <th>Added to DB</th>
                      <th width="60">&nbsp;</th>
                     
                
            </thead>
            <tbody>
                  <tr v-for="row in filteredGarments" v-bind:key="row.garmentID" :class="{'has-background-success' : row.approved == 1, 'has-text-white' : row.approved == 1}">
                    <td >{{row.garmentID}}</td>
                    <td >{{row.garmentname}}</td>
                      
                      <td>{{row.range}}</td>
                      <td>{{row.sku_range_name }} / {{  row.sku_range_code }}</td>
                      <td>{{row.style_name }} / {{  row.style_code }}</td>
                      <td>{{row.delivery_days }}</td>
                      <td>
                        <span class="icon " v-if="row.garment_fully_printed == 1">
                          Yes
                      </span>
                      </td>
                      <td>
                        <span class="icon " v-if="row.garment_part_printed == 1">
                          Yes
                      </span>
                      </td>
                      <td>
                        <span class="icon " v-if="row.garment_cut_sew == 1">
                          Yes
                      </span>
                      </td>
                      <td><div v-if="row.approved == 1">Yes</div></td>
                      <td>{{  row.created_at }}</td>
                      <td>
                          <button class="button is-danger is-small" :disabled="working==true" v-if="row.hidegarment===0 || row.hidegarment=== null">Hide</button>
                          <button class="button is-link is-small" :disabled="working==true" v-if="row.hidegarment==1">Un-hide</button>
                        </td>
                     

            </tr>
            </tbody>
          </table>
        </div>
      
    </div>

      
    
    
    
    
  </div>
</template>

<script>


//import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      garments: [],
      approved_garments: [],
      garment : [],
      garment_id: 0,
      search: '',
      garment_fully_printed: '',
      garment_cut_sew: '',
      garment_part_printed: '',
      approved: '',
      working: false,
      fabrics : [],
      fabric_id: '',
      accessToken: '',
      include_hidden: false,
      new_garment_id: '',
      sku_ranges: [],
      styles: [],
      sku_range_id: '',
      style_id: ''
      
    }
  },
   methods: {
    
    updateIncludeHidden()
    {
        this.include_hidden = !this.include_hidden
      this.getGarments()
    },
      async getGarments() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "garments?order_by=created_at DESC&include_hidden=" + this.include_hidden).then(
               response => {
                this.garments = response 
                this.loading = false;
               }
            );
      },
      
    
    
    
  },
  computed : {
    filteredGarments: function () {
       
        let filteredGarments =  this.garments.filter(function(u) {
            if(  u.garmentEnabled == 1) 
            {
              return 1
            }
            
          })

          if(this.search != '' && this.search != null)
          {
            filteredGarments = filteredGarments.filter(row => (
                row.garmentname.toLowerCase().includes(this.search.toLowerCase())
                || row.range.toLowerCase().includes(this.search.toLowerCase())
                || row.delivery_days.toString().includes(this.search.toLowerCase())
                )
                    )
          }

          return filteredGarments
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getGarments();
          
           
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

